import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ShareMapSelectComponent } from './shareMapSelect.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ShareMapSelect: undefined;
  }
}

modalRenderer.register('ShareMapSelect', ShareMapSelectComponent);
